import React, { useEffect, useMemo, useState } from "react";
import * as image from "../../resources/images";
import { getCapitalized, getSequnceSort, replaceName } from "../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
const ReflectionImage = ({showReflection, selectedOPtion})=>{

     const {
            defaultChildData,
            loggedInUser,
        } = useSelector((state) => state.collections);

    // console.log("selectedOPtion : ", selectedOPtion);

     const sctReflectionImgObj = {
            "excellent": image.Amazing_job,
            "good": image.total_normal,
            "poor": image.being_honest,
            "booster1": image.Amazing_job,  
        }   
        console.log("showReflection : ", showReflection, sctReflectionImgObj[sctReflectionImgObj]);
    return(
         <div className="jobdone">
            <div className="jobtypeimage">
                <img src={sctReflectionImgObj[showReflection]} alt="Amazing_job" />
            </div>
            <div className="text-center">
                <h3 className="fw-600 f-size-20 pb-1">{replaceName(loggedInUser, selectedOPtion?.message)}</h3>
            {/* <p className="lighttextcolor p2">{replaceName(loggedInUser, selectedOPtion?.displayText)}</p> */}
            </div>
        </div>
    )
}
export default ReflectionImage;